import { DatasetTypes } from "../constants/dataset-types";
import {
  getImageInfo,
  getQualityCheckInfo,
  getTabularInfo,
  getUnsupervisedImageInfo,
} from "../store/effects/datasets-effects";

export class Dataset {
  dataActions = {
    [DatasetTypes.IMAGE]: getImageInfo,
    [DatasetTypes.QUALITY_CHECK]: getQualityCheckInfo,
    [DatasetTypes.TABULAR]: getTabularInfo,
    [DatasetTypes.UNSUPERVISED_IMAGE]: getUnsupervisedImageInfo,
  };

  constructor({
    _id = "",
    message = "",
    analysis_execution_id = "",
    analysis_output = {},
    dataInfo = {},
    analysis_status = null,
    created_at = null,
    description = "",
    is_completed,
    is_labeled,
    is_owner,
    is_public,
    label_project_id = "",
    license = "",
    name = "",
    organization = "",
    s3_key = "",
    size = 0,
    tags = [],
    type = "",
    updated_at = "",
    user_id = "",
    singleSensor = [],
    timeData = [],
  } = {}) {
    /** @type {string} */
    this._id = _id;
    /** @type {string} */
    this.name = name;
    /** @type {string} */
    this.description = description;
    /** @type {string} */
    this.message = message;
    /** @type {string} */
    this.analysis_execution_id = analysis_execution_id;
    /** @type {Object} */
    this.analysis_output = analysis_output;
    /** @type {number} */
    this.analysis_status = analysis_status;
    /** @type {string} */
    this.description = description;
    /** @type {boolean} */
    this.is_completed = is_completed;
    /** @type {boolean} */
    this.is_labeled = is_labeled;
    /** @type {boolean} */
    this.is_owner = is_owner;
    /** @type {boolean} */
    this.is_public = is_public;
    /** @type {string} */
    this.label_project_id = label_project_id;
    /** @type {string} */
    this.license = license;
    /** @type {string} */
    this.organization = organization;
    /** @type {string} */
    this.s3_key = s3_key;
    /** @type {number} */
    this.size = size;
    /** @type {Array} */
    this.tags = tags;
    /** @type {string} */
    this.type = type;
    /** @type {Date} */
    this.created_at = new Date(created_at);
    /** @type {Date} */
    this.updated_at = new Date(updated_at);
    /** @type {string} */
    this.user_id = user_id;
    /** @type {Object} */
    this.dataInfo = dataInfo;
    /** @type {string} */
    this.analysisMessage = analysis_output?.format || "";
    /** @type {Array} */
    this.singleSensor = singleSensor;
    /** @type {Array} */
    this.timeData = timeData;
  }

  getDataAction = (type) => {
    return this.dataActions[type];
  };

  addDataInfo = (response) => (this.dataInfo = response);
}
